import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Button, Clearfix, Label } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { omit as _omit, get as _get } from 'lodash';
import { changeUploadContext, resetUploadContext, fileUploadHelper } from 'actions/UploadActions';
import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { blockForm, releaseForm } from 'actions/ActiveFormsActions';
import { addNotification } from 'actions/NotificationsActions';
import { getThumbFileFromEntity } from 'helpers/items';
import { isPluginActive } from 'helpers/whiteLabel';
import { formatEntityErrorsForDisplay } from 'helpers/formStatus';
import EntityStateUpdater from 'component/EntityStateUpdater';
import RoundImage from 'components/layout/RoundImage';
import Breadcrumb from 'components/layout/Breadcrumb';
import Tabs from 'components/layout/Tabs';
import IntlDate from 'components/layout/IntlDate';
import ClientProfile from 'components/layout/client/ClientProfile';
import UserProfile from 'components/layout/client/UserProfile';
import ClientDocs from 'components/layout/client/ClientDocs';
import ClientFinancial from 'components/layout/client/ClientFinancial';
import ClientRoles from 'components/layout/client/ClientRoles';
import ClientTeams from 'components/layout/client/ClientTeams';
import UserResponsibilities from 'components/layout/client/UserResponsibilities';
import ClientHolding from 'components/layout/client/ClientHolding';
import Entity from 'components/Entity';
import Data from 'components/Data';
import PasswordChange from 'components/modals/PasswordChange';
import { entityMetaMapping, ROLE_EMPLOYEE, ROLE_CRM_MASTER, SALES_ACTIVITY_DASHBOARD_PLUGIN, ROLE_WL_ADMIN, ROLE_ADMIN } from 'js/constants';
import may from 'js/security';
import ActiveFormsToolbar from 'components/forms/ActiveFormsToolbar';
import FormErrors from 'components/forms/FormErrors';
import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';
import ClientProvisionServiceList from './ClientProvisionServiceList';
import ClientProvisionService from './ClientProvisionService';
import ClientContactManagement from './ClientContactManagement';
import FormSwitchery from "components/forms/FormSwitchery";
import SubscriptionsForUser from 'components/layout/subscriptions/SubscriptionsForUser';
import Axios from 'axios';
import { confirmAlert } from 'react-confirm-alert';

class UserView extends EntityStateUpdater {
  constructor(props) {
    super(props);

    this.state = {
      showPasswordChange: false,
      entityLoaded: false,
      entityChanged: false,
      activeFormsInitiated: false,
      sendInvitation: false,
    };

    this.entity = new Entity();

    // if we get user data from the outside, we can pass it on to our data entity
    if (props.clientData) {
      this.entity.setData(props.clientData);
    }

    if (props.meta[entityMetaMapping.client] !== undefined && !props.meta[entityMetaMapping.client].pending) {
      this.entity.setMeta(props.meta, entityMetaMapping.client);
    }

    if (this.entity.getDataLoaded() && this.entity.getMetaLoaded()) {
      this.state = {
        ...this.state,
        entityLoaded: true,
        entity: this.entity,
      };
    }

    this.dataRef = React.createRef();
  }

  passwordChangeClick = () => {
    this.setState({ showPasswordChange: true });
  };

  closePasswordChange = () => {
    this.setState({ showPasswordChange: false });
  };

  componentWillMount = () => {
    const { clientId } = this.props;

    // if (false) {
    // } else {
    this.props.updateUploadContext({
      type: 'client_img',
      clientId,
      uploadLink: `/api/avatars/${clientId}.json`,
    });
    // }
  };

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      clientId,
      editSelf,
      meta,
      passwordChangeFormStatus,
      formStatus,
      activeForms,
      data,
      doNotify,
      doBlockForm,
    } = this.props;
    const { entity, entityLoaded, activeFormsInitiated } = this.state;

    if (!prevProps.activeForms.allowEdit && activeForms.allowEdit) {
      if (this.dataRef && this.dataRef.current) {
        this.dataRef.current.fetch();
      }
      this.setState({ entityLoaded: false });
    }

    // new password was saved to the client
    if (
      prevProps.passwordChangeFormStatus.pending &&
      !passwordChangeFormStatus.pending &&
      !passwordChangeFormStatus.hasError
    ) {
      this.closePasswordChange();
      doNotify(1, messages.new_password_set);
    }

    // client data was saved and there was no error
    if (prevProps.formStatus.pending && !formStatus.pending && !formStatus.hasError) {
      this.setState({ entityChanged: false });
      doNotify(1, messages.user_data_saved);
    }

    if (prevProps.data.pending && !data.pending) {
      this.entity.setData(data.data);
      if (this.entity.getMetaLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }

      // we received the user data
      // now we have to see if we can block the page edit to ourselves
      if (!editSelf && !activeFormsInitiated && !may('ROLE_ROOT_EMPLOYEE', this.props.user.roles)) {
        this.setState({ activeFormsInitiated: true }, () => doBlockForm(clientId));
      }
    }

    if (
      meta[entityMetaMapping.client] !== undefined &&
      !meta[entityMetaMapping.client].pending &&
      !this.entity.getMetaLoaded()
    ) {
      this.entity.setMeta(meta, entityMetaMapping.client);
      if (this.entity.getDataLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }
    }

    if (entityLoaded && !prevProps.data.pending && !data.pending) {
      const avatarId = !!_get(data, 'data.profile.avatar.variations') && _get(data, 'data.profile.avatar.id');
      const prevAvatarId = _get(prevProps, 'data.data.profile.avatar.id');
      if (avatarId && avatarId !== prevAvatarId) {
        // we have a new avatar
        // update the entity (quiet)
        const value = entity.createValue('avatar', ['profile'], data.data.profile.avatar);
        this.updateEntity('avatar', value, ['profile'], null, false);

        doNotify(1, messages.file_uploaded);
      }
    }
  };

  componentWillUnmount = () => {
    const { clientId, doResetUploadContext, doReleaseForm } = this.props;
    // release the block so that other users may work on the user data
    doReleaseForm(clientId);
    doResetUploadContext();
  };

  formSubmit = e => {
    e.preventDefault();

    const { clientId, editSelf, activeForms, onSubmit } = this.props;
    const { entity, sendInvitation } = this.state;

    if (editSelf || activeForms.allowEdit) {
      this.setState(
        prevState => ({ entity: prevState.entity.validate() }),
        () => {
          if (this.state.entity.isValid) {
            // ommit unnecessary data
            const data = _omit(this.state.entity.processedData, ['projectLang', 'type']);
            onSubmit(clientId, { ...data, sendInvitation: !!(entity.getProfile().getEmail() && sendInvitation) });
          }
        }
      );
    }
  };

  getTabHeaderList = () => {
    const {
      intl: { messages },
      user: { roles },
      user,
      editSelf,
      editUser,
      projectConfig,
    } = this.props;
    const { entity, entityLoaded } = this.state;
    const result = [];

    result.push(messages.profile);
    if (entityLoaded) {
      if (entity.getType === 'customer') {
        result.push(messages.documents);
      }
    }
    if (may('ROLE_HR_FINANCIAL', roles)) {
      result.push(messages.financial);
    }
    if (may('ROLE_CRM_ROLES', roles)) {
      result.push(messages.roles);
    }
    if (may('ROLE_HR_TEAMS', roles)) {
      result.push(messages.teams);
    }

    // check if it's an employee and that he may edit some external accounts
    if (may(ROLE_EMPLOYEE, roles) && editSelf) {
      let shouldDisplayExternalAccounts = false;

      if (isPluginActive(SALES_ACTIVITY_DASHBOARD_PLUGIN, projectConfig.data)) {
        shouldDisplayExternalAccounts = true;
      }
      /*
      if (shouldDisplayExternalAccounts) {
        result.push(messages.external_accounts);
      }
*/
    }

    if (
      entityLoaded &&
      may(ROLE_CRM_MASTER, entity.getRoles()) &&
      ((may(ROLE_EMPLOYEE, roles) && editSelf) || (may(ROLE_CRM_MASTER, roles) && editUser))
    ) {
      result.push(messages.responsibilities);
    }

    if (
      editUser &&
      ((entityLoaded && entity.data.in_holding && may('ROLE_ADMIN', user.roles)) ||
        may('ROLE_ROOT_EMPLOYEE', user.roles))
    ) {
      // holding settings (parent and ancestors)
      result.push(messages.holding_structure);
    }
    if (editUser && ((entityLoaded && may('ROLE_ADMIN', user.roles)) || may('ROLE_ROOT_EMPLOYEE', user.roles))) {
      result.push(messages.provision_service);
    }
    if (
      editUser &&
      (((entityLoaded && may('ROLE_ADMIN', user.roles)) || may('ROLE_ROOT_EMPLOYEE', user.roles)) &&
        may('ROLE_PROVISION_VALID', user.roles))
    ) {
      result.push(messages.provision_service_documents);
    }

    if (entityLoaded && (may('ROLE_ADMIN', user.roles) || may('ROLE_EMPLOYEE', user.roles))) {
      result.push(messages.contacts);
    }

    result.push(messages.subscriptions_);

    return result;
  };

  getTabContentList = () => {
    const { formStatus, user, editSelf, editUser, activeForms, clientId } = this.props;
    const { entity, entityLoaded } = this.state;
    const result = [];

    const disabled = formStatus.pending || (!editSelf && !activeForms.allowEdit);
    const sharedProps = { entityLoaded, entity, changeEntity: this.changeEntity, disabled };

    result.push(
      <div key="profile">
        <ClientProfile {...sharedProps} user={user} typeOfUser="user" />
      </div>
    );
    if (entityLoaded) {
      if (entity.getType === 'customer') {
        result.push(<ClientDocs clientEntityLoaded={entityLoaded} clientEntity={entity} disabled={disabled} />);
      }
    }
    // financial settings (bank account, legal)
    if (may('ROLE_HR_FINANCIAL', user.roles)) {
      result.push(<ClientFinancial key="financial" {...sharedProps} />);
    }
    if (may('ROLE_WL_ADMIN', user.roles) || may('ROLE_ADMIN', user.roles)) {
      // security roles
      result.push(<ClientRoles key="roles" {...sharedProps} />);
    }
    if (may('ROLE_HR_TEAMS', user.roles)) {
      // client teams
      result.push(<ClientTeams key="teams" {...sharedProps} />);
    }
    /*
        // check if it's an employee and that he may edit some external accounts
        if (may('ROLE_EMPLOYEE', user.roles) && editSelf) {
          let shouldDisplayExternalAccounts = false;

          if (isPluginActive('SALES_ACTIVITY_DASHBOARD', projectConfig.data)) {
            shouldDisplayExternalAccounts = true;
          }

          if (shouldDisplayExternalAccounts) {
            result.push(<ClientExternalAccounts {...sharedProps} />);
          }

    }
*/

    if (
      entityLoaded &&
      may(ROLE_CRM_MASTER, entity.getRoles()) &&
      ((may(ROLE_EMPLOYEE, user.roles) && editSelf) || (may(ROLE_CRM_MASTER, user.roles) && editUser))
    ) {
      result.push(<UserResponsibilities key="responsibilities" {...sharedProps} />);
    }

    if (
      editUser &&
      ((entityLoaded && entity.data.in_holding && may('ROLE_ADMIN', user.roles)) ||
        may('ROLE_ROOT_EMPLOYEE', user.roles))
    ) {
      // holding settings (parent and ancestors)
      result.push(<ClientHolding key="holding" {...sharedProps} user={user} />);
    }

    if (editUser && ((entityLoaded && may('ROLE_ADMIN', user.roles)) || may('ROLE_ROOT_EMPLOYEE', user.roles))) {
      result.push(<ClientProvisionService key="serviceTypes" {...sharedProps} user={user} />);
    }
    if (
      editUser &&
      (((entityLoaded && may('ROLE_ADMIN', user.roles)) || may('ROLE_ROOT_EMPLOYEE', user.roles)) &&
        may('ROLE_PROVISION_VALID', user.roles))
    ) {
      result.push(<ClientProvisionServiceList key="provisionServiceList" {...sharedProps} user={user} />);
    }

    if (entityLoaded && (may('ROLE_ADMIN', user.roles) || may('ROLE_EMPLOYEE', user.roles))) {
      result.push(
        <ClientContactManagement
          clientEntityLoaded={entityLoaded}
          clientEntity={entity}
          disabled={disabled}
          contactReferenceId={entity?.getProfile?.()?.getContactReferenceId()}
          updateDefaultContact={this.updateDefaultContact}
          clientId={clientId}
        />
      );
    }
    
    result.push(<SubscriptionsForUser clientId={clientId !== user.username ? clientId : null} />);

    return result;
  };

  updateDefaultContact = (contactReferenceId, addressReferenceId, callback) => {
    const { clientId, doNotify } = this.props;
    const { entity } = this.state;
    let url = `/api/clients/${clientId}/contacts/${contactReferenceId}/makedefault.json`;
    Axios.post(url)
      .then(({ data }) => {
        entity.updateValue('contactReferenceId', contactReferenceId, ['profile']);
        entity.updateValue('addressReferenceId', addressReferenceId, ['profile']);
        this.setState({ entity });
      })
      .catch(error => {
        // handle error
        if (Axios.isCancel(error)) {
          console.log('POST request canceled', error);
        } else {
          doNotify(0, 'Error updating default contact');
          console.log(error);
        }
      });
  };

  getTabKeepMounted = () => {
    const keepMounted = [];
    return keepMounted;
  };

  getBreadcrumb = () => {
    if (this.props.breadcrumb) {
      return this.props.breadcrumb;
    }

    const { entityLoaded, entity } = this.state;

    let clientHeader;
    if (entityLoaded) {
      clientHeader = entity.getProfile().getFirstName() + ' ' + entity.getProfile().getLastName();
    }

    const crumbs = this.props.crumbs.slice();
    crumbs.push({ link: null, name: clientHeader });

    return <Breadcrumb crumbs={crumbs} />;
  };

  manualUpload = files => {
    for (let i = 0; i < files.length; i++) {
      const file = files.item(i);
      this.props.uploadFile(file, this.props.upload.context.uploadLink, this.props.upload.context.data);
    }
  };

  render() {
    const {
      intl: { messages },
      clientId,
      formStatus,
      data,
      user,
    } = this.props;
    const { entityLoaded, entityChanged, entity } = this.state;

    let clientHeader;
    let metaTitle = messages.user;
    if (entityLoaded) {
      clientHeader = entity.getProfile().getFirstName() + ' ' + entity.getProfile().getLastName();
      metaTitle += ' - ' + clientHeader;
    }

    return (
      <DocMeta tags={generateMetaTags(messages.meta.user_details, metaTitle)}>
        <div class="padding-25 sm-padding-10">
          {/* data should not be fetched if we got the data as props */}
          {/* we do need the meta data though */}
          {this.props.clientData !== undefined ? (
            <Data dataName="user" />
          ) : (
            <Data ref={this.dataRef} dataName="user" url={`/api/users/${clientId}.json`} data={data} />
          )}
          <FormErrors formStatus={formStatus} additionalErrors={formatEntityErrorsForDisplay(entity, messages)} />

          <form method="put" onSubmit={this.formSubmit}>
            {this.getBreadcrumb()}

            <section class="panel no-padding">
              <div class="client-profile-header">
                <Row>
                  <Col xs={12} sm={8}>
                    <div class="text-center p-t-10 p-b-10 pull-left" style={{ width: '260px' }}>
                      {entityLoaded && getThumbFileFromEntity(entity.getProfile().getAvatar()) ? (
                        <RoundImage
                          class="uploadProfileIcon"
                          size={75}
                          url={getThumbFileFromEntity(entity.getProfile().getAvatar()).getWebLink()}
                        >
                          <div className="pull--40 uploadProfileIconIn">
                            <input
                              type="file"
                              ref={ref => (this.uploadInput = ref)}
                              style={{ display: 'none' }}
                              onChange={e => this.manualUpload(e.target.files)}
                            />
                            <Button bsSize="sm" class="btn-rounded" onClick={() => this.uploadInput.click()}>
                              <i className="fa fa-upload m-r-10" /> {messages.upload}
                            </Button>
                          </div>
                        </RoundImage>
                      ) : (
                        <RoundImage size={75}>
                          <div class="relative">
                            <i class="far fa-user-circle hint-text" style={{ fontSize: '170px' }} />

                            {entityLoaded && (
                              <div class="pull--40">
                                <input
                                  type="file"
                                  ref={ref => (this.uploadInput = ref)}
                                  style={{ display: 'none' }}
                                  onChange={e => this.manualUpload(e.target.files)}
                                />
                                <Button bsSize="sm" class="btn-rounded" onClick={() => this.uploadInput.click()}>
                                  <i class="fa fa-upload m-r-10" /> {messages.upload}
                                </Button>
                              </div>
                            )}
                          </div>
                        </RoundImage>
                      )}
                    </div>
                    <div class="pull-left">
                      {this.props.editUser && (
                        <h5 class="m-t-40 text-uppercase">
                          <span>{messages.user_since}</span> {entityLoaded && <IntlDate date={entity.getCdate()} />}
                        </h5>
                      )}
                      <h3 class="m-t-20">
                        {clientHeader}{' '}
                        <Label bsStyle={entityLoaded && entity.getUserRoleSet() === 'Standard' ? 'success' : 'primary'}>
                          {entityLoaded && entity.getUserRoleSet()}
                        </Label>
                      </h3>
                      <h5 class="m-t-20 text-uppercase">{entityLoaded && entity.getProfile().getCompany()}</h5>
                      <div class="m-b-15">
                        <a href={`/api/clients/${clientId}/export.json`} class="btn" target="_blank">
                          Export
                        </a>
                      </div>
                    </div>
                    <Clearfix />
                  </Col>
                </Row>
              </div>
            </section>

            <Row>
              <Col xs={12}>
                <ActiveFormsToolbar
                  formStatus={formStatus}
                  entityChanged={entityChanged}
                  formType="user"
                  formId={clientId}
                  fabActions={
                    <Button disabled={formStatus.pending} onClick={this.passwordChangeClick} bsSize="lg">
                      {messages.change_password}
                    </Button>
                  }
                />
              </Col>
            </Row>

            <Row>
              <Col xs={12}>
                <Tabs
                  tabs={this.getTabHeaderList()}
                  tabContent={this.getTabContentList()}
                  keepMounted={this.getTabKeepMounted()}
                />
              </Col>
            </Row>
            {(may(ROLE_WL_ADMIN, user.roles) || may(ROLE_ADMIN, user.roles)) && entityLoaded && (
              <Row>
                <Col xs={12}>
                  <div className="form-group form-group-default">
                    <FormSwitchery
                      name="sendInvite"
                      label={
                        messages.send_invitation_with_username_and_password +
                        ' (' +
                        (entity.getProfile().getEmail() || '-') +
                        ')'
                      }
                      value
                      checked={!!(this.state.sendInvitation && entity.getProfile().getEmail())}
                      onChange={(name, value) => this.setState({ sendInvitation: value })}
                      disabled={!!(formStatus.pending || !entity.getProfile().getEmail())}
                    />
                  </div>
                </Col>
              </Row>
            )}
          </form>

          <div id="password-change">
            <PasswordChange client={entity} show={this.state.showPasswordChange} close={this.closePasswordChange} />
          </div>
        </div>
      </DocMeta>
    );
  }
}
UserView.defaultProps = {
  editUser: false,
  editSelf: false,
  editClient: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    data: state.data.user,
    projectConfig: state.data.projectConfig,
    meta: state.entityMeta,
    user: state.login.user,
    passwordChangeFormStatus: state.formStatus.passwordChange,
    formStatus: state.formStatus.userEdit,
    activeForms: state.activeForms,
    upload: state.upload,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    updateUploadContext: newContext => {
      dispatch(changeUploadContext(newContext));
    },
    doResetUploadContext: () => {
      dispatch(resetUploadContext());
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    onSubmit: (clientId, args) => {
      formStatusDispatchHelper('userEdit', `/api/users/${clientId}.json`, args, 'put', dispatch);
    },
    uploadFile: fileUploadHelper(dispatch),
    doBlockForm: id => {
      dispatch(blockForm('user', id));
    },
    doReleaseForm: id => {
      dispatch(releaseForm('user', id));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(UserView)
  )
);
